<template>
	<div>
		<div class="container">
			<div class="handle-box">
				<el-form label-width="80px">
					<div class="form-items-wrapper">
						<el-form-item label="代理商" v-if="isAdmin">
							<el-select size="small" @change="agentChange" v-model="query.agentId" filterable clearable
								placeholder="代理商" class="handle-select" style="width: 260px">
								<el-option v-for="item in agents" :key="item.value" :label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="企业" v-if="isNormal || isAgent">
							<el-select size="small" v-model="query.companyId" @change="companyChange" filterable
								clearable placeholder="企业" class="handle-select" style="width: 260px">
								<el-option v-for="item in companys" :key="item.value" :label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="品牌">
							<el-select size="small" v-model="query.cardsId" filterable clearable placeholder="请选择品牌"
								class="handle-select" style="width: 260px">
								<el-option v-for="item in serverLists" :key="item.cardsId" :label="item.cardType"
									:value="item.cardsId"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="类型">
							<el-select size="small" v-model="query.type" filterable clearable placeholder="类型"
								class="handle-select" style="width: 260px">
								<el-option v-for="item in typeList" :key="item.value" :label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="坐席号码">
							<el-input size="small" v-model="query.phone" clearable placeholder="请输入坐席号码"
								class="handle-input" style="width: 260px"></el-input>
						</el-form-item>
						<el-form-item label="主叫号码">
							<el-input size="small" v-model="query.userPhone" clearable placeholder="请输入主叫号码"
								class="handle-input" style="width: 260px"></el-input>
						</el-form-item>
						<el-form-item label="被叫号码">
							<el-input size="small" v-model="query.phoneNumber" clearable placeholder="请输入被叫号码"
								class="handle-input" style="width: 260px"></el-input>
						</el-form-item>
						<el-form-item label="时间">
							<el-date-picker size="small" v-model="timeArr" type="daterange" unlink-panels
								range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
								style="width: 260px"></el-date-picker>
						</el-form-item>
						<el-form-item>
							<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
								@click="handleSearch">搜索</el-button>
							<el-button size="small" type="primary" :class="[theme]" icon="el-icon-download"
								@click="handleExport">导出</el-button>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div style="display: flex;flex-direction: row;margin-bottom: 20px;justify-content: space-between;">
				<div class="phone-details">
					<div class="tit">本月充值金额(元)</div>
					<span class="text">{{customData.topUp||0}}</span>
				</div>
				<div class="phone-details">
					<div class="tit">本月消费时长(分钟)</div>
					<span class="text">{{Math.abs(customData.useMinutes)||0}}</span>
				</div>
				<div class="phone-details">
					<div class="tit">本月总时长(分钟)</div>
					<span class="text">{{customData.minutes||0}}</span>
				</div>
				<div class="phone-details">
					<div class="tit">本月剩余时长(分钟)</div>
					<span class="text">{{customData.minutes - Math.abs(customData.useMinutes)||0}}</span>
				</div>
			</div>
			<el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
				max-height="600" @selection-change="handleSelectionChange"
				:header-cell-style="{ 'text-align': 'center' }" :row-style="{ height: '20px' }"
				:cell-style="{ padding: '6px' }" stripe v-loading="loading">
				<el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="agentName" label="代理" align="center"
					v-if="isAdmin&&!query.agentId"></el-table-column>
				<el-table-column prop="companyName" label="企业" align="center"
					v-if="(isAdmin||isAgent)&&!query.companyId"></el-table-column>
				<el-table-column prop="cardName" label="品牌" align="center"></el-table-column>
				<el-table-column prop="phone" label="坐席账号" align="center"></el-table-column>
				<el-table-column prop="userPhone" label="主叫号码" align="center"></el-table-column>
				<el-table-column prop="phoneNumber" label="被叫号码" align="center"></el-table-column>
				<el-table-column prop="type" label="类型" align="center"></el-table-column>
				<el-table-column prop="time" label="消费时间(分钟)" align="center" width="155"></el-table-column>
				<el-table-column prop="remaining" label="剩余时长(分钟)" align="center" width="155">
					<template #default="scope">
						<span>{{scope.row.remaining||0}}分钟</span>
					</template>
				</el-table-column>
				<el-table-column prop="useMinutes" label="使用时长(分钟)" align="center" width="155">
					<template #default="scope">
						<span>{{scope.row.useMinutes||0}}分钟</span>
					</template>
				</el-table-column>
				<el-table-column prop="price" label="消费金额" align="center" width="100px">
					<template #default="scope">
						<span>{{scope.row.price||0}}元</span>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination background layout="total, sizes, prev, pager, next, jumper"
					:current-page="query.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
					:page-size="query.pageSize" :total="pageTotal" @size-change="handleSizeChange"
					@current-change="handlePageChange"></el-pagination>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		fetchDepartment
	} from '../../api/index.js';
	import {
		fetchAgent
	} from '../../api/agentIndex.js';
	import {
		fetchCompanyByAgentId,
		fetchDefaultCompanies
	} from '../../api/companyIndex';
	import {
		accountJobUseRecord,
		serverList,
		exportUseRecord
	} from '../../api/cdrBatch.js';
	export default {
		name: 'cdrBatchConsumptionDetails',
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				query: {
					companyId: '',
					agentId: '',
					phone: '',
					userPhone: '',
					phoneNumber: '',
					type: '',
					userId: localStorage.getItem('user'),
					startTime: '',
					endTime: '',
					cardsId: '',
					pageIndex: 1,
					pageSize: 10,
				},
				serverLists: [], //SIPServer服务器的列表
				agents: [],
				companys: [],
				tableData: [],
				contentList: [],
				outsideList: [],
				multipleSelection: [],
				isAdmin: false,
				isAgent: false,
				isNormal: false,
				pageTotal: 0,

				role: '',
				timeArr: [],
				customData: '',
				typeList: [{
						value: '1',
						label: '充值套餐'
					}, {
						value: '2',
						label: '充值加量包'
					},
					{
						value: '3',
						label: '通话'
					}
				]
			};
		},
		created() {
			this.role = localStorage.getItem('ms_role');
			this.init();
			if (this.role === 'admin') {
				this.isAdmin = true;
				this.isNormal = true;
			}

			if (this.role == 'agent') {
				this.isAgent = true;
				this.isNormal = true;
			}
			this.getTime()
			this.getData();
			this.getServerList();
			this.updatePaginationStyle();
		},
		methods: {
			updatePaginationStyle() {
				let pagination = document.getElementById('pagination');
				if (!pagination) {
					pagination = document.createElement('style');
					pagination.id = 'dynamic-tab-style';
					document.head.appendChild(pagination);
				}
				pagination.innerHTML = `
				    .active {
				        background-color: ${this.theme8} !important;
						color: #fff !important;
				    }
					.number:hover {
				        color: ${this.theme8} !important;
				    }
					.active:hover {
					    color: #fff !important;
					}
					.more:hover {
					    color: ${this.theme8} !important;
					}
				`;
			},
			//sip服务器列表
			getServerList() {
				let data = {
					pageIndex: 1,
					pageSize: 30
				}
				serverList(data).then(res => {
					if (res?.code === 200) {
						this.serverLists = res.data.list;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getfetchDefaultCompanies() {
				this.query.companyId = '';
				let data = {
					currentUserId: localStorage.getItem('user'),
					subAgentId: this.query.subAgentId
				};
				fetchDefaultCompanies(data).then(res => {
					this.companys = res.data;
					if (this.role == 'agent') {

						this.getData();
					}
				});
			},



			init() {
				fetchAgent(localStorage.getItem('user')).then(res => {
					this.agents = res.data;
				});
				this.getfetchDefaultCompanies();
			},
			getData() {
				this.loading = true;
				if (this.timeArr === null) {
					this.query.startTime = '';
					this.query.endTime = '';
					this.$message.error('时间不能为空');
				} else {
					let startTime = this.toDateTimeStr(this.timeArr[0]);
					let endTime = this.toDateTimeStr(this.timeArr[1]);
					this.query.startTime = startTime;
					this.query.endTime = endTime;
				}
				this.query.userId = localStorage.getItem('user');
				accountJobUseRecord(this.query).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData = res.data.list;
						this.customData = res.customData;
						this.pageTotal = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getTime() {
				//时间
				let startTime = new Date(new Date());
				let endTime = new Date();
				this.timeArr.push(startTime);
				this.timeArr.push(endTime);
			},
			toDateTimeStr(date) {
				let y = date.getFullYear();
				let m = date.getMonth() + 1;
				let d = date.getDate();
				if (m < 10) {
					m = '0' + m;
				}
				if (d < 10) {
					d = '0' + d;
				}
				return y + '-' + m + '-' + d;
			},
			agentChange(agentId) {
				this.query.agentId = agentId;
				this.query.companyId = '';
				this.query.departmentId = '';
				this.query.userId = '';
				if (agentId) {
					let data = {
						subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
						agentId: agentId
					};
					fetchCompanyByAgentId(data).then(res => {
						this.companys = res.data;
					});
				}
			},
			companyChange(companyId) {
				this.query.companyId = companyId;
				this.query.departmentId = '';
				this.query.userId = '';
				let data = {
					companyId: companyId,
					currentUserId: localStorage.getItem('user')
				};
				fetchDepartment(data).then(res => {
					this.departments = res.data;
					this.query.pageIndex = 1;
					// this.getData();
				});
			},


			// 多选操作
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			// 触发搜索按钮
			handleSearch() {
				this.query.pageIndex = 1;
				this.getData();
			},
			handleSizeChange(val) {
				this.query.pageSize = val;
				this.query.pageIndex = 1; // 重置到第一页
				this.getData();
			},
			// 分页导航
			handlePageChange(val) {
				this.query.pageIndex = val;
				this.getData();
			},



			handleExport() {
				if (this.timeArr === null) {
					this.query.startTime = '';
					this.query.endTime = '';
					this.$message.error('请选择时间段');
				} else {
					let startTime = this.toDateTimeStr(this.timeArr[0]);
					let endTime = this.toDateTimeStr(this.timeArr[1]);
					this.query.startTime = startTime;
					this.query.endTime = endTime;
				}
				this.query.userId = localStorage.getItem('user');
				exportUseRecord(this.query).then(res => {
					this.loading = false;
					const blob = new Blob([res], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
					});
					let downloadElement = document.createElement('a');
					let href = window.URL.createObjectURL(blob);
					downloadElement.href = href;
					let fileName = this.query.startTime + '-' + this.query.endTime + '账单明细' + '.xlsx';
					downloadElement.download = fileName;
					document.body.appendChild(downloadElement);
					downloadElement.click();
					document.body.removeChild(downloadElement);
					window.URL.revokeObjectURL(href);
				});
			},
		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.down {
		border: 1px solid #dcdfe6;
		background: #4f7afd;
		color: #ffffff;
		transition: 0.1s;
		font-weight: 500;
		padding: 8px 16px;
		font-size: 12px;
		border-radius: 4px;
		margin-left: 10px;

		display: inline-block;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.table {
		width: 100%;
		font-size: 12px;
	}

	.red {
		color: #ff0000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.grid-con-icon {
		font-size: 50px;
		width: 100px;
		height: 100px;
		text-align: center;
		line-height: 100px;
		color: #fff;
	}

	.phone-details {
		height: 80px;
		width: 15%;
		border-radius: 10px;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		padding: 10px 24px;
		background-color: #ecf4ff;

		.tit {
			font-size: 16px;
			color: #222;
		}

		.text {
			font-size: 16px;
			color: #222;
			font-weight: 700;
		}
	}

	.grid-cont-right {
		flex: 1;
		text-align: center;
		font-size: 20px;
		font-weight: bold;
		color: #999;
	}

	.grid-content {
		display: flex;
		align-items: center;
		height: 100px;
	}

	.form-items-wrapper {
		display: flex;
		flex-wrap: wrap;
		/* 允许子元素换行 */
		justify-content: flex-start;
		/* 水平对齐方式（可选） */
		align-items: center;

	}

	.form-items-wrapper .el-form-item {
		/* 根据需要调整 el-form-item 的样式 */
		flex: 0 0 auto;
		/* 不放大也不缩小，但会占据空间 */
		margin: 5px 10px 5px 0;
		display: flex;
		flex-direction: row;
		/* 如果使用 gap 属性，则不需要这个 */
	}

	.form-items-wrapper .el-form-item__label {
		/* 调整标签样式（可选） */
	}

	/deep/ .handle-box .el-form-item__content {
		margin-left: 0 !important;
	}

	/deep/ .handle-box .el-form-item__label {
		font-size: 14px !important;
	}
</style>
<style>
	.import-visible .el-upload {
		width: 100% !important;
		display: flex !important;
		flex-direction: column !important;
		align-items: center !important;
		justify-content: center !important;
	}
</style>